// removed by extract-text-webpack-plugin
module.exports = {"red":"#e40000","grey":"#707070","detailsMargin":"_1SMPuS9yTGNzkoIWpIMZ_S","withMinWidth":"L5fsDRhDZ8c9pVlVh366w","withPaddingRight":"U20BqEO678ptnJZvIIWQx","rowMarginBottom":"_2faYWSV91g0AT2xy4odqMX"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/foundations/Motion/MotionUsage.css
// module id = 778
// module chunks = 0